export default __webpack_public_path__ + "static/media/recruit_table_icon_9.67c16a4e.svg";